module.exports = __webpack_public_path__ + "img/1549551837.818c5ad9.jpg";